import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import AddRideFare from './AddRideFare';
import messages from '../../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.addRideFare);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <AddRideFare title={title} />
      </AdminLayout>
    ),
  };
}

export default action;
